import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import {
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  onCambioMoneda,
  calcularTotales,
  round,
  lpad,
} from "../../util/varios";
import moment from "moment";

import useTableScroll from "../useTableScroll";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoProducto from "../../catalogos/catalogoProducto";
import CatalogoOrdenCompras from "../../catalogos/catalogoOrdenesdCompra";
import RegistrarProveedor from "../../catalogos/catalogoAgregarProveedor";

const TablaOrdenCompra = () => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let anio = JSON.parse(sessionStorage.getItem("anioactu"));
  let idagente = JSON.parse(sessionStorage.getItem("idagente"));
  const fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const accbtnordencompra = JSON.parse(
    sessionStorage.getItem("accbtnordencomprac")
  );

  const headCells = [
    { label: "COD.", textAlign: "center", width: "40px" },
    { label: "PRODUCTO", textAlign: "center", width: "160px" },
    { label: "CNTD", textAlign: "center", width: "20px" },
    { label: "UNI.ALT.", textAlign: "center", width: "50px" },
    { label: "PRECIO PVDR.", textAlign: "center", width: "50px" },
    { label: "IVA", textAlign: "center", width: "20px" },
    { label: "MONTO IVA.", textAlign: "center", width: "50px" },
    { label: "MONTO TOTAL", textAlign: "center", width: "50px" },
    {
      label: <i className="fas fa-trash" />,
      textAlign: "center",
      width: "20px",
    },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtNombreCliente = useRef();
  const txtDescuento = useRef();
  const txtSubTotal = useRef();
  const txtTotalIva = useRef();
  const txtExentoTotal = useRef();
  const txtTotal = useRef();
  const txtDirClient = useRef();
  const txtCedRifv = useRef();
  const txtNombreVendedor = useRef();
  const txtCantidad = useRef([]);
  const txtPrecio = useRef([]);
  const txtId = useRef([]);
  const txtCedRif = useRef();
  const txtCodigo = useRef();
  const txtNumPresupuesto = useRef();
  const txtFecha = useRef();
  const txtFechaVencimiento = useRef();
  const btnProducto = useRef();
  const txtIdmoneda = useRef();
  const txtTipoOrdenCompra = useRef();
  const txtFormaPago = useRef();

  const [idCliente, setIdCliente] = useState("");
  const [idVendedor, setIdVendedor] = useState("");
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [desde, setDesde] = useState(0);
  const [catalogoPresu, setCatalogoPresu] = useState(false);
  const [tituloHeader, setTituloHeader] = useState(
    "Gestionar Orden de Compra/Servicio."
  );
  const [numNota, setNumNota] = useState("");
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [statusordencompra, setStatusordencompra] = useState(0);
  const [tasaor, setTasaor] = useState(0);
  const [idmoney, setIdmoney] = useState(0);
  const [records, setRecords] = useState([]);
  const [idalmacen, setIdAlmacen] = useState(null);
  const [mostrar, setMostrar] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [indice, setIndice] = useState(null);
  const [body, setBody] = useState(null);
  const [catregistrarcliente, setCatregistrarcliente] = useState(false);
  const [combomoneda, setComboMoneda] = useState([]);
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [valparametro, setValparametro] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [fechav, setFechav] = useState(0);
  const [activate, setActivate] = useState(false);
  const [castabla, setCastabla] = useState(true);

  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [monedaCambio, setMonedaCambio] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
  });
  const [acpt, setAcpt] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [totales, setTotales] = useState({
    subtotal: 0.0,
    descuento: 0.0,
    exento: 0.0,
    sujeto: 0.0,
    iva: 16.0,
    totaliva: 0.0,
    total: 0.0,
  });

  const seleccionarAgente = () => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idagente}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtNombreVendedor.current.value = response.data.nombre;
            txtCedRifv.current.value = response.data.rif;
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarAlmacen = () => {
    let campos = "*";
    let nomtab = "almacen";
    let nomid = "ventas";
    let id = "true";
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setIdAlmacen(response.data.idalmacen);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un Almacen de venta",
              icono: "informacion",
            });
            blanquear();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Orden de Compra/Servicio.");
    setFechav(0);
    setTasaor(0);
    setStatusordencompra(0);
    txtId.current.value = "";
    txtNombreCliente.current.value = "";
    txtNombreVendedor.current.value = "";
    txtCedRif.current.value = "";
    txtCedRifv.current.value = "";
    txtDirClient.current.value = "";
    txtTotal.current.value = "";
    txtTotalIva.current.value = "";
    txtSubTotal.current.value = "";
    txtCodigo.current.value = "";
    txtFecha.current.value = moment(fechaSistema).format("YYYY-MM-DD");
    txtFormaPago.current.value = "3";
    txtTipoOrdenCompra.current.value = "1";
    setActivate(false);
    setRecords([]);
    setIndice(null);
    setAcpt(false);
    setComboMoneda([]);
    setHabilitarCat(true);
    setNumNota("");
    setVisibleBtn("visible");
    setCastabla(true);
    setOperacion(0);
    setHabilitado(true);
    setHabilitadoNU(false);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: false,
      cancelar: false,
      catalogo: true,
      catalogoper: true,
    });
    setMoneda({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: false,
      valormoneda: 1.0,
    });
    setMonedaCambio({
      idmoneda: "4",
      descripcion: "DOLAR",
      simbolo: "$",
      predeterminada: false,
      subpredeterminada: true,
      valormoneda: 1.0,
    });
    for (let i = 0; i < combomoneda.length; i++) {
      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
        txtIdmoneda.current.selectedIndex = i;
      }
    }

    setTotales({
      subtotal: 0.0,
      descuento: 0.0,
      exento: 0.0,
      sujeto: 0.0,
      iva: 16.0,
      totaliva: 0.0,
      total: 0.0,
    });
  };

  const eliminarProducto = (producto) => (e) => {
    e.preventDefault();
    var data = [...records];
    var elementos = [];

    for (let i = 0; i < data.length; i++) {
      if (producto.idproducto !== data[i].idproducto) {
        elementos.push(data[i]);
      }
    }
    setRecords(elementos);
    setTotales(calcularTotales(elementos));
  };

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);
    if (valparametro === "proveedor") {
      txtNombreCliente.current.value = values.nombre;
      txtDirClient.current.value = values.direccion;
      txtCedRif.current.value = values.rif;
      setIdCliente(values.idagente);
    }
  };

  const onCatalogo = (val) => {
    if (val === 1) {
      setValparametro("proveedor");
      setCatalogoCliente(true);
    }
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (txtTipoOrdenCompra.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Tipo de Orden no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtTipoOrdenCompra.current.focus();
    } else if (txtFormaPago.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Forma de Pago no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtFormaPago.current.focus();
    } else if (
      txtCedRif.current.value.trim() === "" ||
      txtNombreCliente.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el Proveedor",
        icono: "informacion",
      });
      sigue = false;
      txtCedRif.current.focus();
    } else if (
      txtCedRifv.current.value === "" ||
      txtCedRifv.current.value.trim() === "" ||
      txtNombreVendedor.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el Vendedor",
        icono: "informacion",
      });
      sigue = false;
      txtCedRifv.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No hay Producto agregados",
        icono: "informacion",
      });
      sigue = false;
      btnCancela.current.focus();
    }

    if (sigue) {
      var orden = [];
      var ordendeta = [];
      var tasa = 0.0;

      tasa = monedaSub.valormoneda;

      orden.push({
        idordendecompra:
          operacion === 1 && txtCodigo.current.value !== null
            ? 0
            : operacion === 2
              ? txtCodigo.current.value
              : txtCodigo.current.value,
        codigo: numNota,
        cedularif: txtCedRif.current.value,
        montototal:
          parseFloat(
            txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")
          ) / tasa,
        totaliva:
          parseFloat(
            txtTotalIva.current.value.replace(/\./g, "").replace(",", ".")
          ) / tasa,
        idproveedor: idCliente,
        idcomprador: operacion === 1 ? idagente : idVendedor,
        fecha: txtFecha.current.value,
        idmoneda: idmoney,
        status: "0",
        tipoorden: txtTipoOrdenCompra.current.value,
        formapago: txtFormaPago.current.value,
        fechavencimiento:
          txtFormaPago.current.value === "4"
            ? txtFechaVencimiento.current.value
            : null,
        tasa: tasa,
      });

      for (let i = 0; i < records.length; i++) {
        ordendeta.push({
          idproducto: records[i].idproducto,
          cantidad: records[i].cantidad,
          punitario: records[i].precio / records[i].valormoneda,
          iva: records[i].iva,
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idunidadalterna: records[i].idunidadalterna,
        });
      }

      setBody({
        orden: orden,
        ordendeta: ordendeta,
      });

      setDesde(2);
      let msg = "";
      if (operacion === 1) {
        msg = "¿Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "¿Esta Seguro de Modificar estos Datos?.";
      } else if (operacion === 3) {
        msg = "¿Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/ordencompra/actualizarordencompra/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "¡Registro " + response.data.idpe + " Creado Correctamente!",
              icono: "exito",
            });
            /* window.open(op.reportes + "reporte=Pedido" + "&CODIGO=" + response.data.idpe, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"); */
            if (txtFormaPago.current.value === "4") {
              txtFechaVencimiento.current.value =
                moment(fechaSistema).format("YYYY-MM-DD");
            }
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "¡Registro " +
                response.data.idpe +
                " Modificado Correctamente!",
              icono: "exito",
            });
            if (txtFormaPago.current.value === "4") {
              txtFechaVencimiento.current.value =
                moment(fechaSistema).format("YYYY-MM-DD");
            }
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "¡Registro " + response.data.idpe + " Eliminado Correctamente!",
              icono: "exito",
            });
          }

          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          mensaje = error.response.data.message;
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      var prod = records;
      setDesde(0);
      setRecords(prod);
    } else if (desde === 2) {
      setDesde(0);
      procesarRegistro();
    }
  };

  const seleccionarProducto = (index, idubi, idprod) => {
    let campos =
      "p.*, (select trim(descripcion) as descripcionuni from unidadmedida where idunidadmedida = p.idunidadmedida) as descripcionuni," +
      "(select trim(descripcion) as descripcionunialt from unidadmedida where idunidadmedida = p.idunidadalterna) as descripcionunialt ";
    let nomtab = "producto as p";
    let nomid = "p.codigo";
    let nomid2 = 'activo';
    let id = idprod;
    let id2 = true;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = [...records];

          if (response.data !== "") {
            if (response.data.servicio) {
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "El producto no existe o esta Inactivo",
                icono: "error",
              });
              txtCantidad.current[records.length - 1].value = "1,00";
            } else {
              for (let i = 0; i < records.length; i++) {
                if (records[i].idproducto === response.data.idproducto) {
                  setActivate(false);
                  setMensaje({
                    mostrar: true,
                    titulo: "Notificacion",
                    texto: "El PRODUCTO YA EXISTE",
                    icono: "error",
                  });
                  return;
                }
              }

              let uni = [];

              if (parseInt(response.data.idunidadalterna) === 0) {
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                ];
              } else {
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                  {
                    idunidad: response.data.idunidadalterna,
                    descripcion: response.data.descripcionunialt,
                    tipo: "alterna",
                  },
                ];
              }

              let precio = 0.0;
              let tipounidad = 0;

              if (
                response.data.idunidadcompra === response.data.idunidadalterna
              ) {
                precio = response.data.costoproveedoralter;
                tipounidad = 1;
              } else {
                precio = response.data.costoproveedor;
                tipounidad = 0;
              }

              // precio = precio * response.data.valormoneda;
              //  precio = precio / moneda.valormoneda;

              let montoiva = round((precio * response.data.ivaventa) / 100, 2);

              if (index !== null) {
                data[index] = {
                  idproducto: response.data.idproducto,
                  codigo: response.data.codigo,
                  cantidad: 1.0,
                  nombrecorto: response.data.nombrecorto,
                  precio: precio,
                  iva: response.data.ivaventa,
                  motoiva: montoiva,
                  descuento: "",
                  total: precio,
                  totald: precio,
                  unidad: uni,
                  idunidadmedida: response.data.idunidadmedida,
                  idunidadalterna: response.data.idunidadalterna,
                  idmoneda: response.data.idmoneda,
                  valormoneda: monedaCambio.valormoneda,
                  tipounidad: tipounidad,
                  valorfactor: response.data.valorfactor,
                  costoproveedor: response.data.costoproveedor,
                };
              } else {
                data.push({
                  idproducto: response.data.idproducto,
                  codigo: response.data.codigo,
                  cantidad: 1.0,
                  nombrecorto: response.data.nombrecorto,
                  precio: precio,
                  iva: response.data.ivaventa,
                  motoiva: montoiva,
                  descuento: "",
                  total: precio,
                  totald: precio,
                  unidad: uni,
                  idunidadmedida: response.data.idunidadmedida,
                  idunidadalterna: response.data.idunidadalterna,
                  idmoneda: response.data.idmoneda,
                  valormoneda: monedaCambio.valormoneda,
                  tipounidad: tipounidad,
                  valorfactor: response.data.valorfactor,
                  costoproveedor: response.data.costoproveedor,
                });
              }

              setRecords(data);
              setTotales(calcularTotales(data));
              setIndice(index);

              if (index !== null) {
                setTimeout(() => txtCantidad.current[index].focus(), 300);
              } else {
                setTimeout(
                  () => txtCantidad.current[data.length - 1].focus(),
                  300
                );
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "El producto no existe o esta Inactivo",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        txtId.current.value = "";
        txtId.current.focus();
      });
  };

  const seleccionarDetalle = () => {
    let id = txtCodigo.current.value;
    let endpoint = `${op.conexion}/api/ordencompra/seleccionarordencompra?idordendecompra=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let prod = [];
            let uni = [];

            for (let i = 0; i < response.data.length; i++) {
              if (parseInt(response.data[i].idunidadalterna) === 0) {
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];
              } else {
                if (response.data[i].tipounidad === 0) {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                  ];
                } else {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                  ];
                }
              }

              let montoiva =
                (parseFloat(response.data[i].punitario) *
                  parseFloat(response.data[i].ivaventa)) /
                100;
              montoiva = round(montoiva, 2) * parseFloat(response.data[i].cantidad);

              prod.push({
                idproducto: response.data[i].idproducto,
                codigo: response.data[i].codigo,
                cantidad: parseFloat(response.data[i].cantidad),
                nombrecorto: response.data[i].nombrecorto,
                precio: parseFloat(response.data[i].punitario),
                iva: parseFloat(response.data[i].iva),
                ivaventa: parseFloat(response.data[i].ivaventa),
                motoiva: montoiva,
                descuento: response.data[i].descuento,
                total:
                  parseFloat(response.data[i].cantidad) *
                  parseFloat(response.data[i].punitario),
                totald:
                  parseFloat(response.data[i].cantidad) *
                  parseFloat(response.data[i].punitario),
                unidad: uni,
                idunidadmedida: response.data[i].idunidadmedida,
                idunidadalterna: response.data[i].idunidadalterna,
                costocalculado: response.data[i].costocalculado,
                costocalculadoalter: response.data[i].costocalculadoalter,
                utipreciomaxi: response.data[i].utipreciomaxi,
                utipreciomaxialter: response.data[i].utipreciomaxialter,
                tipounidad: response.data[i].tipounidad,
                valormoneda: monedaCambio.valormoneda,
                idmoneda: response.data[i].idmoneda,
                costoproveedor: parseFloat(response.data[i].punitario),
                tasa: monedaCambio.valormoneda,
              });
            }
            setRecords(prod);
            setTotales(calcularTotales(prod));
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const agregarProducto = (producto) => {
    setMostrar(false);
    seleccionarProducto(indice, idalmacen, producto.codigo);
  };

  const editarProducto = (index) => (e) => {
    e.preventDefault();
    setMostrar(true);
    setIndice(index);
  };

  const validarCantidad = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "1,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      if (event.target.id === "cantidad") {
        var canti = parseFloat(
          event.target.value.replace(/\./g, "").replace(",", ".")
        );

        let data = [...records];
        if (canti > data[index].cantidadE) {
          data[index].cantidad = 1.0;
          canti = 1.0;
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "La  cantidad no debe ser mayor a la cantidad existente",
            icono: "informacion",
          });
        }

        // let ivss = (data[index].precio * canti * data[index].iva) / 100;
        //  let ivb = ivss * data[index].valormoneda;

        data[index].cantidad = canti;
        data[index].motoiva = round((data[index].precio * data[index].iva) / 100, 2) * canti;
        data[index].total = data[index].precio * canti;
        //  data[index].totald = data[index].precio * canti;

        setRecords(data);
        setTotales(calcularTotales(data));
        if (event.which === 13) {
          if (index < data.length - 1) {
            setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
          } else {
            btnProducto.current.focus();
          }
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarIdProducto = (index) => (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProducto(index, idalmacen, event.target.value);
      }
    }
  };

  const onRegistrarClientes = (values) => {
    setCatregistrarcliente(false);
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (
        accbtnordencompra &&
        accbtnordencompra.toString().substring(0, 1) === "1"
      ) {
        setVisibleBtn("hidden");
        setTituloHeader("Incluir Orden de Compra/Servicio.");
        setHabilitado(false);
        seleccionarMonedas();
        seleccionarAgente();
        seleccionarCidgoorden("idordendecompra");
        setCastabla(false);
        setOperacion(1);
        setAcpt(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoper: false,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (
        accbtnordencompra &&
        accbtnordencompra.toString().substring(1, 2) === "1"
      ) {
        setTituloHeader("Editar Orden de Compra/Servicio.");
        setVisibleBtn("hidden");
        setHabilitado(false);
        seleccionarMonedas();
        setHabilitarCat(false);
        setCastabla(false);
        setAcpt(false);
        setOperacion(2);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (
        accbtnordencompra &&
        accbtnordencompra.toString().substring(3, 4) === "1"
      ) {
        setTituloHeader("Eliminar Orden de Compra/Servicio.");
        setVisibleBtn("hidden");
        setHabilitado(false);
        seleccionarMonedas();
        setAcpt(false);
        setHabilitarCat(false);
        setCastabla(true);
        setOperacion(3);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (
        accbtnordencompra &&
        accbtnordencompra.toString().substring(2, 3) === "1"
      ) {
        setTituloHeader("Consultar Orden de Compra/Servicio.");
        setVisibleBtn("hidden");
        seleccionarMonedas();
        setAcpt(true);
        setHabilitado(false);
        setCastabla(true);
        setOperacion(4);
        setHabilitarCat(false);
        setHabilitadoNU(true);
        setDesde(7);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 6) {
      setVisibleBtn("visible");
      blanquear();
    }
  };

  const seleccionarMonedas = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let x = 0;
          if (response.data.length > 0) {
            setComboMoneda(response.data);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMonedaSub(response.data[i]);
                setIdmoney(response.data[i].idmoneda);
                setMonedaCambio({
                  idmoneda: response.data[i].idmoneda,
                  descripcion: response.data[i].descripcion,
                  simbolo: response.data[i].simbolo,
                  predeterminada: response.data[i].predeterminada,
                  subpredeterminada: response.data[i].subpredeterminada,
                  valormoneda: 1.0,
                });
                x = i;
              } else if (response.data[i].predeterminada) {
                setMoneda(response.data[i]);
              }
            }
          }
          setTimeout(() => (txtIdmoneda.current.selectedIndex = x), 200);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarProveedor = (rif) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "rif";
    let nomid2 = "proveedor";
    let id = rif;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtCedRif.current.value = response.data.rif;
            txtNombreCliente.current.value = response.data.nombre;
            txtDirClient.current.value = response.data.direccion;
            setIdCliente(response.data.idagente);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un cliente con este codigo",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarResponsable = (id) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtCedRifv.current.value = response.data.rif;
            txtNombreVendedor.current.value = response.data.nombre;
            setIdVendedor(response.data.idagente);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un vendedor con este codigo",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = () => {
    let campos = "*";
    let nomtab = "ordendecompra";
    let nomid = "idordendecompra";
    let id = txtCodigo.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setStatusordencompra(response.data.status);
            setTasaor(response.data.tasa);
            txtFecha.current.value = moment(response.data.fecha).format(
              "YYYY-MM-DD"
            );
            setNumNota(response.data.codigo);
            txtCedRif.current.value = response.data.cedularif;
            txtTipoOrdenCompra.current.value = parseInt(
              response.data.tipoorden
            );
            txtFormaPago.current.value = parseInt(response.data.formapago);
            if (parseInt(response.data.formapago) === 4) {
              setFechav(1);
              txtFechaVencimiento.current.value = moment(
                response.data.fechavencimiento
              ).format("YYYY-MM-DD");
            } else {
              setFechav(0);
            }
            seleccionarProveedor(response.data.cedularif);
            seleccionarResponsable(response.data.idcomprador);
            //seleccionarMoneda(response.data.idmoneda);
            seleccionarDetalle();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe.",
              icono: "informacion",
            });
            txtCodigo.current.value = "";
            txtCodigo.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "idordendecompra") {
          seleccionarRegistro();
        }
      }
    }
  };

  const seleccionarCidgoorden = (id) => {
    let tabla = "ordendecompra";
    let endpoint = `${op.conexion}/api/ordencompra/consultacodigos?tabla=${tabla}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.numeroasignado > 0) {
            let to = parseFloat(response.data.numeroasignado) + 1;
            let cerrrou = '00000';
            let paddedNumber = lpad(to.toString(), cerrrou, 5);
            setNumNota("OC" + paddedNumber);
          } else {
            setNumNota("OC00001");
          }

        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const onCatalogoPresupuesto = (values) => {
    setCatalogoPresu(false);
    txtCodigo.current.value = values.idordendecompra;
    seleccionarRegistro();
  };

  const onChangeFecha = (e) => {
    if (e.target.name === "formapago") {
      if (e.target.value === "4") {
        setFechav(1);
      } else if (e.target.value === "3") {
        setFechav(0);
      }
    }
  };

  const onChangeMoneda = (e) => {
    let i = e.target.value;
    const cambio = onCambioMoneda({
      moneda: combomoneda[i],
      productos: records,
      monedaPre: moneda,
      monedaSub: monedaSub,
    });
    setMonedaCambio(cambio.monedacambio);
    setRecords(cambio.data);
  };

  const onChangeUnidad = (index) => (e) => {
    e.preventDefault();
    let data = [...records];
    let precio = 0.0;
    let montoiva = 0.0;
    let tipounidad = 0;

    if (parseInt(e.target.value) === parseInt(data[index].idunidadalterna)) {
      tipounidad = 1;
      precio =
        parseFloat(data[index].precio) / parseFloat(data[index].valorfactor);
    } else if (
      parseInt(e.target.value) === parseInt(data[index].idunidadmedida)
    ) {
      tipounidad = 0;
      precio =
        parseFloat(data[index].precio) * parseFloat(data[index].valorfactor);
    }

    montoiva = (precio * parseFloat(data[index].iva)) / 100;

    data[index].tipounidad = tipounidad;
    data[index].precio = precio;
    data[index].unidad = data[index].unidad.reverse();
    data[index].total = precio * data[index].cantidad;
    data[index].montoiva = montoiva * data[index].cantidad;

    setRecords(data);
    setTotales(calcularTotales(data));
  };

  const imprimirOrdendeCompra = () => {
    if (
      accbtnordencompra &&
      accbtnordencompra.toString().substring(4, 5) === "1"
    ) {
      if (txtCodigo.current.value !== "") {
        let id = txtCodigo.current.value;
        window.open(
          op.reportes + "reporte=Ordencompra" + "&CODIGO=" + id,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  useEffect(() => {
    seleccionarAlmacen();
    seleccionarMonedas();
  }, []);

  const onChange = (e) => {

    if (e.target.name === "tipoorden") {

      let tipoorden = txtNumPresupuesto.current.value.substring(2, 8);

      if (e.target.value === "1") {
        let compra = "OC" + tipoorden
        setNumNota(compra);
      } else {
        let compra = "OS" + tipoorden
        setNumNota(compra);
      }

    }

  }

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 " style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-11 mx-auto py-2 card shadow ">
            <div
              className="col-md-12 row border-azul mx-auto justify-content-between rounded py-2"
              style={{ fontSizeAdjust: "0.6" }}
            >
              <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light d-flex align-items-center">
                <div className="col-md-5">
                  <h3>{tituloHeader}</h3>
                </div>
                <div className="col-pd-450 mx-auto px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text bg-transparent border-0 fs-6 fw-bold text-light"
                      id="inputGroup-sizing-sm"
                    >
                      {numNota.substring(0, 2) === 'OC' ? 'N° Order de Compra:' :
                        numNota.substring(0, 2) === 'OS' ? 'N° Order de Servicio:' : ''}{" "}
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      ref={txtNumPresupuesto}
                      disabled
                      className="form-control mt-1 bg-transparent border-0 text-light fw-bold fs-5"
                      value={numNota}
                      name="numpresu"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <a href="/inicio" className="text-light ">
                    <i className="fas fa-times mx-2"></i>
                    <span className="fw-bold">Salir</span>
                  </a>
                </div>
              </div>

              <div className="col-md-12 row px-0 m-0">
                <div className="col-pd-220 mb-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CODIGO:{" "}
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="idordendecompra"
                      onKeyUp={handleInputNumeroChange}
                      disabled={
                        operacion === 1 || operacion === 0 ? true : false
                      }
                      ref={txtCodigo}
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button
                      type="button"
                      onClick={() => setCatalogoPresu(true)}
                      disabled={habilitarCat}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>

                <div className="col-pd-260 mb-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO DE ORDEN:
                    </label>
                    <select
                      className="form-select"
                      ref={txtTipoOrdenCompra}
                      onChange={onChange}
                      name="tipoorden"
                      disabled={
                        operacion === 4 || operacion === 3 || operacion === 0
                          ? true
                          : false
                      }
                      aria-label="Default select example"
                    >
                      <option value="1">COMPRA</option>
                      <option value="2">SERVICIO</option>
                    </select>
                  </div>
                </div>

                <div className="col-pd-270 mb-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO DE PAGO:
                    </label>
                    <select
                      className="form-select"
                      ref={txtFormaPago}
                      name="formapago"
                      onChangeCapture={onChangeFecha}
                      disabled={
                        operacion === 4 || operacion === 3 || operacion === 0
                          ? true
                          : false
                      }
                      aria-label="Default select example"
                    >
                      <option value="3">CONTADO</option>
                      <option value="4">CRÉDITO</option>
                    </select>
                  </div>
                </div>

                {fechav === 1 ? (
                  <div className="col-pd-350 mb-1">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        FECHA DE VENCIMIENTO:
                      </label>
                      <input
                        autoComplete="off"
                        type="date"
                        disabled={castabla}
                        className="form-control text-uppercase fs-6"
                        ref={txtFechaVencimiento}
                        aria-label="Sizing example input"
                        defaultValue={moment(fechaSistema).format("YYYY-MM-DD")}
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="col-pd-220 ml-auto mb-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA:
                    </label>
                    <input
                      autoComplete="off"
                      type="date"
                      disabled={castabla}
                      className="form-control text-uppercase fs-6"
                      ref={txtFecha}
                      aria-label="Sizing example input"
                      defaultValue={moment(fechaSistema).format("YYYY-MM-DD")}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-8 mb-2 py-1">
                <div className="col-md-12 mx-auto row border-azul rounded py-2">
                  <span className="fw-bold col-md-12">
                    Datos del Proveedor{" "}
                    <a
                      style={{
                        pointerEvents:
                          botones.catalogoper === true ? "none" : false,
                        color: botones.catalogoper
                          ? "rgb(183, 183, 183)"
                          : "#1d0345",
                        backgroundColor: botones.catalogoper
                          ? "#fff"
                          : "transparent",
                      }}
                      type="button"
                      onClick={() => onCatalogo(1)}
                      className="text-info rounded-circle"
                      title="Buscar Proveedor"
                    >
                      <i className=" fas fa-search"></i>
                    </a>
                    <a
                      style={{
                        pointerEvents:
                          botones.catalogoper === true ? "none" : false,
                        color: botones.catalogoper
                          ? "rgb(183, 183, 183)"
                          : "#1d0345",
                        backgroundColor: botones.catalogoper
                          ? "#fff"
                          : "transparent",
                      }}
                      type="button"
                      onClick={() => setCatregistrarcliente(true)}
                      className="text-info rounded-circle ml-2"
                      title="Registrar Proveedor"
                    >
                      <i className=" fas fa-plus"></i>
                    </a>
                  </span>
                  <div className="col-md-3 mb-1">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        CEDULA/RIF:{" "}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled
                        ref={txtCedRif}
                        className="form-control bg-transparent fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                  <div className="col-md-9 mb-1">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        NOMBRE:{" "}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled
                        ref={txtNombreCliente}
                        className="form-control bg-transparent fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 mb-1">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        DIRECCION:{" "}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled
                        ref={txtDirClient}
                        className="form-control bg-transparent fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-2 py-1 row m-0">
                <div className="col-md-12 mx-auto border-azul rounded row py-2">
                  <span className="fw-bold">Datos del Responsable</span>
                  <div className="col-md-6 py-1">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        CEDULA/RIF:{" "}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled
                        ref={txtCedRifv}
                        className="form-control bg-transparent fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        NOMBRE:{" "}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled
                        ref={txtNombreVendedor}
                        className="form-control bg-transparent fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                </div>

                {
                  <div className="col-pd-330 py-1 ml-auto px-0">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        TIPO DE MONEDA:
                      </label>
                      <select
                        className="form-control form-control-sm form-select fw-bold fs-6"
                        disabled={
                          operacion === 3 || operacion === 0 ? true : false
                        }
                        ref={txtIdmoneda}
                        onChange={onChangeMoneda}
                      >
                        {combomoneda &&
                          combomoneda.map((item, index) => (
                            <option key={index} value={index}>
                              {" "}
                              {`${item.descripcion} ${item.simbolo
                                } ${formatMoneda(
                                  item.valormoneda
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}`}{" "}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                }
              </div>

              <div
                className="col-md-12 border-azul rounded px-0"
                style={{ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 250,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden table-bordered">
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell className="align-middle bg-light text-center p-0 d-flex">
                            <input
                              type="text"
                              style={{
                                borderBottomRightRadius: 0,
                                borderTopRightRadius: 0,
                              }}
                              disabled={castabla}
                              ref={(el) => (txtId.current[index] = el)}
                              className="form-control form-control-sm bg-light text-right text-center fs-6"
                              defaultValue={item.codigo}
                              onChange={(e) =>
                                (e.target.value = e.target.value.toUpperCase())
                              }
                              onKeyUp={validarIdProducto(index)}
                              onBlur={validarIdProducto(index)}
                            />
                            {(operacion === 1 || operacion === 2) && (
                              <button
                                type="button"
                                style={{
                                  borderBottomLeftRadius: 0,
                                  borderTopLeftRadius: 0,
                                }}
                                disabled={castabla}
                                onClick={editarProducto(index)}
                                className="btn btn-sm btn-primary"
                              >
                                <i className="fas ">-</i>
                              </button>
                            )}
                          </TableCell>

                          <TableCell
                            className="align-baseline bg-light"
                            style={{ textAlign: "center", width: "160px" }}
                          >
                            {item.nombrecorto}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light p-0"
                            style={{ width: "20px" }}
                          >
                            <input
                              type="text"
                              disabled={castabla}
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="cantidad"
                              defaultValue={formatMoneda(
                                item.cantidad
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtCantidad.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={validarCantidad(index)}
                              onBlur={validarCantidad(index)}
                            />
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light p-0"
                            style={{ width: "50px" }}
                          >
                            <select
                              className="form-select form-select-sm fs-6"
                              disabled={castabla}
                              onChange={onChangeUnidad(index)}
                              aria-label=".form-select-sm example"
                            >
                              {item.unidad &&
                                item.unidad.map((item2, x) => (
                                  <option key={x} value={item2.idunidad}>
                                    {" "}
                                    {item2.descripcion}{" "}
                                  </option>
                                ))}
                            </select>
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-center p-0"
                            style={{ width: "50px" }}
                          >
                            <input
                              type="text"
                              disabled={castabla}
                              //onKeyUp={validarPrecio(index)}
                              //onBlur={validarPrecio(index)}
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="precio"
                              defaultValue={formatMoneda(
                                (item.precio * item.valormoneda)
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtPrecio.current[index] = el)}
                            />
                            {/* {formatMoneda(item.precio.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light text-center"
                            style={{ width: "20px" }}
                          >
                            {formatMoneda(
                              item.iva
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light text-right"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              (item.motoiva * item.valormoneda)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light text-right"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              (item.precio * item.cantidad * item.valormoneda)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light p-0"
                            style={{ textAlign: "center", width: "20px" }}
                          >
                            <button
                              disabled={castabla}
                              style={{
                                visibility:
                                  (operacion === 4 || operacion === 3) &&
                                  "collapse",
                              }}
                              className="btn btn-sm mx-1 btn-danger rounded-circle"
                              onClick={eliminarProducto(item)}
                            >
                              <i className="fa fa-trash"></i>{" "}
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                    <TableRow
                      style={{
                        padding: "0",
                        visibility:
                          (operacion === 4 ||
                            operacion === 0 ||
                            operacion === 3) &&
                          "collapse",
                      }}
                    >
                      <TableCell className="align-middle bg-light text-center p-0 d-flex">
                        <input
                          type="text"
                          style={{
                            borderBottomRightRadius: 0,
                            borderTopRightRadius: 0,
                          }}
                          className="form-control form-control-sm bg-light text-right"
                          onChange={(e) =>
                            (e.target.value = e.target.value.toUpperCase())
                          }
                          onKeyUp={validarIdProducto(null)}
                          onBlur={validarIdProducto(null)}
                        />
                        <button
                          type="button"
                          style={{
                            borderBottomLeftRadius: 0,
                            borderTopLeftRadius: 0,
                          }}
                          onClick={() => setMostrar(true)}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="fas ">-</i>
                        </button>
                      </TableCell>
                      <TableCell
                        className="align-baseline bg-light"
                        style={{ textAlign: "center", width: "160px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light"
                        style={{ textAlign: "center", width: "20px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light text-center"
                        style={{ width: "50px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light text-center"
                        style={{ width: "50px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light text-center"
                        style={{ width: "20px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light text-right"
                        style={{ width: "50px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light text-right"
                        style={{ width: "50px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light"
                        style={{ width: "20px" }}
                      ></TableCell>
                    </TableRow>
                  </TableBody>
                </TblContainer>
              </div>
              <div className="col-md-12 row m-0 px-0">
                <div className="col-lg-8 mt-auto">
                  {visibleBtn === "visible" ? (
                    <div className="col-pd-botones">
                      <div className="col-md-12 row m-0">
                        <button
                          disabled={botones.incluir}
                          onClick={onBotones(1)}
                          className="btn btn-sm col ml-1 mb-1 btn-primary rounded-pill"
                          title="Incluir Almacen"
                        >
                          <i className="fas fa-plus"> Incluir </i>{" "}
                        </button>
                        <button
                          disabled={botones.consultar}
                          onClick={onBotones(4)}
                          className="btn btn-sm col ml-1 mb-1 btn-info rounded-pill"
                          title="Consultar Almacen"
                        >
                          <i className="fas fa-eye"> Consultar</i>{" "}
                        </button>
                        <button
                          disabled={botones.modificar}
                          onClick={onBotones(2)}
                          className="btn btn-sm col ml-1 mb-1 btn-warning rounded-pill"
                          title="Modificar Almacen"
                        >
                          <i className="fa fa-edit"> Modificar</i>{" "}
                        </button>
                        <button
                          disabled={botones.eliminar}
                          onClick={onBotones(3)}
                          className="btn btn-sm col ml-1 mb-1 btn-danger rounded-pill"
                          title="Eliminar Almacen"
                        >
                          <i className="fa fa-trash"> Eliminar</i>{" "}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="col-pd-360 row m-0 ml-auto">
                      {habilitadoNU === true ? (
                        <button
                          ref={btnAcepta}
                          onClick={imprimirOrdendeCompra}
                          disabled={
                            txtCodigo.current.value !== "" ? false : true
                          }
                          className="btn btn-sm rounded-pill col ml-1 btn-primary"
                        >
                          <i className="fas fa-print"> Imprimir</i>
                        </button>
                      ) : (
                        ""
                      )}
                      <button
                        ref={btnAcepta}
                        disabled={acpt}
                        onClick={onChangeValidar}
                        className="btn btn-sm col ml-1 rounded-pill btn-success"
                      >
                        <i className="fas fa-check-circle"> Aceptar</i>
                      </button>
                      <button
                        ref={btnCancela}
                        disabled={habilitado}
                        onClick={onBotones(6)}
                        className="btn btn-danger col ml-1 btn-sm rounded-pill"
                      >
                        <i className="fas fa-window-close"> Cancelar</i>
                      </button>
                    </div>
                  )}
                </div>
                <div
                  className="col-lg-4 border-azul rounded shadow"
                  style={{ backgroundColor: "#dbeeff" }}
                >
                  <div
                    className="input-group input-group-sm col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      SUBTOTAL {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtSubTotal}
                      value={formatMoneda(
                        (totales.subtotal * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      EXENTO {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtExentoTotal}
                      value={formatMoneda(
                        (totales.exento * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      DESCUENTO {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtDescuento}
                      value={formatMoneda(
                        (totales.descuento * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      IVA Sobre(
                      {formatMoneda(
                        totales.iva
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      %) {monedaCambio.simbolo}:{" "}
                      {formatMoneda(
                        (totales.sujeto * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtTotalIva}
                      value={formatMoneda(
                        (totales.totaliva * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      TOTAL {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtTotal}
                      value={formatMoneda(
                        (totales.total * monedaCambio.valormoneda)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CatalogoCliente
        show={catalogoCliente}
        nomid={valparametro}
        onHideCancelar={() => setCatalogoCliente(false)}
        onHideAceptaCatalogo={onCatalogoCliente}
      />

      <CatalogoProducto
        show={mostrar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
        onHideAceptaCatalogo={agregarProducto}
      />

      <CatalogoOrdenCompras
        show={catalogoPresu}
        nomid="ordencompra"
        onHideCancelar={() => setCatalogoPresu(false)}
        onHideAceptaCatalogo={onCatalogoPresupuesto}
        condicion="true"
      />

      <RegistrarProveedor
        show={catregistrarcliente}
        op={operacion}
        onHideCancelar={() => setCatregistrarcliente(false)}
        onHideAceptaCatalogo={onRegistrarClientes}
      />

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaOrdenCompra;



// WEBPACK FOOTER //
// ./src/components/compra/tablaOrdenCompra.js